module.exports = __webpack_public_path__ + "static/media/298288.47d22f8a.png";